<template>
  <div class="pa-7" id="summary">
   <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
 <div class="row">
<v-col
      xs="12"
      sm="12"
      md="7"
      lg="7"
      xl="7"
>
 <v-card-text class="summary">
                {{ description }}
          </v-card-text>
          </v-col>
<v-col
      xs="12"
      sm="12"
      md="5"
      lg="5"
      xl="5">
              <v-img :src="src"></v-img>
              </v-col>
</div>
</div>
</template>

<style>
.summary {
  white-space:pre-wrap;
  word-wrap:break-word;
  margin-top:-1rem;
}
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '概要',
      // タイトル横のアイコン
      icon: 'mdi-message-bulleted',
      // 説明文
      description: `
      患者は、スマホ、携帯、PCから当日順番待ち予約や時間予約を行えます。
      時間予約では、ワクチン予約も行えます。
      ワクチン枠の細かな設定も可能です。

      医院に合わせて細かにカスタマイズ可能で、
      ワクチン予約システムに特化したカスタマイズも可能です。

      ご試用可能ですのでお問合せください。`,
      // 画像
      src: require('../../assets/Products/reserve.jpg')

    }
  }
}
</script>
